"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  children: true,
  dangerouslySetInnerHTML: true,
  key: true,
  ref: true,
  autoFocus: true,
  defaultValue: true,
  defaultChecked: true,
  innerHTML: true,
  suppressContentEditableWarning: true,
  onFocusIn: true,
  onFocusOut: true,
  // deprecated
  valueLink: true,
  checkedLink: true,
  // react different naming
  allowFullScreen: true
};